import { useQuery } from '@tanstack/react-query';
import { api } from '@/lib/api-client';

export type CroPublicSettings = {
  'site.name'?: string;
  'site.tagline'?: string;
  'site.whatsapp'?: string;
  'cro.guarantee'?: string;
  'cro.scarcity'?: string;
};

export function useCroSettings() {
  return useQuery({
    queryKey: ['cms', 'settings'],
    queryFn: () => api.get<CroPublicSettings>('/cms/settings'),
    staleTime: 5 * 60_000,
    retry: 0,
  });
}

export function useTestimonials() {
  return useQuery({
    queryKey: ['cms', 'testimonials'],
    queryFn: () =>
      api.get<
        Array<{
          id: string;
          name: string;
          content: string;
          rating?: number;
          role?: string | null;
        }>
      >('/cms/testimonials'),
    staleTime: 5 * 60_000,
    retry: 0,
  });
}

export type PublicFaq = {
  id: string;
  question: string;
  answer: string;
  category: string | null;
};

export function usePublicFaqs() {
  return useQuery({
    queryKey: ['cms', 'faqs'],
    queryFn: () => api.get<PublicFaq[]>('/cms/faqs'),
    staleTime: 5 * 60_000,
    retry: 0,
  });
}
